"use client";

import React, { useEffect } from "react";
import Image from "next/image";
import {
  Qualifications,
  QualificationSections,
  QualificationCard,
} from "@/.storyblok/types/319751/storyblok-components";
import { SbBlokData, storyblokEditable } from "@storyblok/react";

interface QualificationsProps {
  blok?: Qualifications & SbBlokData;
}

const QualificationsComponent: React.FC<QualificationsProps> = ({ blok }) => {
  useEffect(() => {
    if (typeof window !== "undefined" && window.bootstrap) {
      const tooltipTriggerList = Array.from(
        document.querySelectorAll('[data-bs-toggle="tooltip"]')
      );
      tooltipTriggerList.forEach((tooltipTriggerEl) => {
        new window.bootstrap.Tooltip(tooltipTriggerEl);
      });
    }
  }, []);

  if (!blok) {
    return null;
  }

  const { title, text, body } = blok;

  const renderSection = (section: QualificationSections) => {
    const { qualifications = [], is_reverse } = section;

    return (
      <div
        key={section._uid}
        className={`mx-auto justify-content-start align-items-center g-3 g-sm-4 horizontal-scrolling${
          is_reverse ? " horizontal-scrolling-reverse" : ""
        }`}
      >
        {[0, 1].map((_, index) => (
          <div
            key={`${section._uid}-${index}`}
            className="horizontal-scrolling-inner"
          >
            {qualifications.map((qualification: QualificationCard, logoIndex) => (
              <div
                key={`${qualification._uid}-${logoIndex}`}
                className="col-auto mb-3 mb-lg-4 card rounded-3 shadow card-lighter border-0 p-2 me-3 me-lg-4"
              >
                {qualification.image?.filename && (
                  <Image
                    src={qualification.image.filename}
                    width={120}
                    height={120}
                    alt={qualification.alt_image || "Qualification Logo"}
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title={qualification.alt_image || "Qualification Logo"}
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                    loading="lazy"
                    quality={75}
                  />
                )}
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div
      {...(blok && storyblokEditable(blok))}
      className="section-qualifications bg-light py-4 py-md-5"
    >
      {title && (
        <div className="container text-center">
          <h2 className="text-center text-primary mb-4">{title}</h2>
          <p className="lead mb-5">{text}</p>
        </div>
      )}

      {body?.map((section) => renderSection(section))}
    </div>
  );
};

export default QualificationsComponent;